<div class="d-flex flex-column gap-2">
  <div class="d-flex justify-content-between align-items-center w-100">
    <ix-typography format="display">{{ 'general.filter' | translate }}
    </ix-typography>
    <ix-pill [outline]="true" variant="neutral">
      {{ 'battery_pass.list.result_counter' | translate: {results: numberOfFoundPassports} }}
    </ix-pill>
  </div>

  <ix-input
    class="w-100"
    label="{{ 'battery_pass.search_bar.passport_id' | translate }}"
    name="passportId"
    [(ngModel)]="criteria.passportId"
    #passportId
    (ngModelChange)="onCriteriaChange()">
    @if (passportId.value) {
      <ix-icon-button
        (click)="onClearSearch('passportId')"
        icon="clear"
        id="clear-button-id"
        onkeypress=""
        size="16"
        slot="end"
        variant="subtle-tertiary"/>
    }
  </ix-input>

  <ix-input
    class="w-100"
    label="{{ 'battery_pass.search_bar.passport_name' | translate }}"
    name="passportName"
    [(ngModel)]="criteria.passportName"
    #passportName
    (ngModelChange)="onCriteriaChange()">
    @if (passportName.value) {
      <ix-icon-button
        (click)="onClearSearch('passportName')"
        icon="clear"
        id="clear-button-name"
        onkeypress=""
        size="16"
        slot="end"
        variant="subtle-tertiary"/>
    }
  </ix-input>

  <ix-checkbox-group class="w-100"
    label="{{ 'battery_pass.list.type' | translate }}">
    <ix-checkbox
      label="{{ 'battery_pass.list.master' | translate }}"
      (checkedChange)="onFlagToggleTypeMaster($event.detail)">
    </ix-checkbox>
    <ix-checkbox
      label="{{ 'battery_pass.search_bar.type.child' | translate }}"
      (checkedChange)="onFlagToggleTypeChild($event.detail)">
    </ix-checkbox>
  </ix-checkbox-group>

  <ix-checkbox-group class="w-100"
    label="{{ 'battery_pass.search_bar.passport_status' | translate }}">
    <ix-checkbox
      label="{{ 'battery_pass.list.draft' | translate }}"
      [checked]="criteria.passportStatus?.draft === true"
      (checkedChange)="onFlagToggleStatusDraft($event.detail)">
    </ix-checkbox>
    <ix-checkbox
      label="{{ 'battery_pass.list.complete' | translate }}"
      [checked]="criteria.passportStatus?.done === true"
      (checkedChange)="onFlagToggleStatusDone($event.detail)">
    </ix-checkbox>
  </ix-checkbox-group>

  <ix-select
    class="w-100"
    label="{{ 'battery_pass.list.product' | translate }}"
    [attr.i-1-8n-placeholder]="'battery_pass.search_bar.select_option' | translate"
    [value]="criteria.schemaId || 'notDefined'"
    (valueChange)="onSchemaChange($event)">
    <ix-select-item
      label="{{ 'battery_pass.search_bar.all_products' | translate }}"
    value="notDefined"></ix-select-item>
    @for (schema of schemas; track schema) {
      <ix-select-item
        [label]="schema.name + ' (' + (schema | schemaVersionLabel: schemas) + ')'"
        [value]="schema.id">
      </ix-select-item>
    }
  </ix-select>

  @if (!reloadCreateHappened) {
    <div class="d-flex flex-column">
      <ix-field-label class="hydrated">
        {{ 'battery_pass.search_bar.created' | translate }}
      </ix-field-label>
      <div class="d-flex align-items-center w-100">
        <ix-date-dropdown
          class="flex-grow-1 w-100"
          (dateRangeChange)="onCreatedDateRangeChange($event)"
          [maxDate]="tomorrowDate"
          [i18nNoRange]="'battery_pass.search_bar.no_range_set' | translate"
          [i18nDone]="'general.apply' | translate"
          [locale]="currentLocale()"
          variant="secondary">
        </ix-date-dropdown>
        @if (createDateSelected) {
          <ix-icon-button
            (click)="clearCreatedDateRange()"
            class="ms-2"
            icon="clear"
            id="clear-button-date-created"
            onkeypress=""
            size="16"
            variant="subtle-tertiary"/>
        }
      </div>
    </div>
  }

  @if (!reloadUpdateHappened) {
    <div class="d-flex flex-column">
      <ix-field-label class="hydrated">
        {{ 'battery_pass.search_bar.modified' | translate }}
      </ix-field-label>
      <div class="d-flex align-items-center w-100">
        <ix-date-dropdown
          class="flex-grow-1 w-100"
          (dateRangeChange)="onUpdatedDateRangeChange($event)"
          [maxDate]="tomorrowDate"
          [i18nNoRange]="'battery_pass.search_bar.no_range_set' | translate"
          [i18nDone]="'general.apply' | translate"
          [locale]="currentLocale()"
          variant="secondary">
        </ix-date-dropdown>
        @if (updateDateSelected) {
          <ix-icon-button
            (click)="clearUpdatedDateRange()"
            class="ms-2"
            icon="clear"
            id="clear-button-date-update"
            onkeypress=""
            size="16"
            variant="subtle-tertiary"/>
        }
      </div>
    </div>
  }
</div>
